export default __webpack_public_path__ + "static/media/RedHatDisplay-Black.0e9d1074.woff";